<template>
  <div>
    <el-card shadow="always">
      <line-detail
        ref="lineDetail"
        :formData="detailFormData"
        :disabled="isDisableEditForm"
      />
    </el-card>
    <el-card shadow="always" class="mt-2">
      <line-point
        ref="linePoint"
        :code="code"
        :tableData="pointList"
        :disabled="isDisableEditForm"
      />
      <div class="d-flex justify-content-end mt-2 mb-2">
        <el-button
          type="primary"
          size="small"
          @click="save()"
          v-if="!isDisableEditForm"
          :disabled="detailFormData.lineStatus !== 'N'"
        >
          保存线路
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
// import EditForm from '../components/edit-form/index'
import { mapActions } from 'vuex'
import LinePoint from './components/line-point.vue'
import LineDetail from './components/line-detail'
// import LinePoint from './components/line-point'
export default {
  name: 'contract-line-detail',
  components: {
    LineDetail,
    LinePoint,
  },
  data() {
    return {
      code: '',
      disabled: false,
      pointList: [],
      detailFormData: {
        lineType: 'Z',
        lineStatus: 'N',
        useDaySet: [],
      },
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.code = this.params.lineCode
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (this.pageType === 'add') {
        return
      }
      let params = {
        lineCode: this.code,
      }
      this.$api.contractLineDetailApi(params).then((res) => {
        this.detailFormData = res.body
        this.detailFormData.useDaySet = JSON.parse(
          this.detailFormData.useDaySet
        )
        this.pointList = res.body.pointList
      })
    },

    async save() {
      // 获取线路主信息
      const getFormData = await this.$refs.lineDetail.getFormData()
      if (!getFormData) {
        return
      }
      // 获取线路节点信息
      const getPointData = await this.$refs.linePoint.getLinePointData()
      if (!getPointData) {
        return
      }

      //合成线路提交参数
      let params = {
        ...getFormData,
        ...getPointData,
      }
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .contractLineSaveApi(params)
        .then((res) => {
          loadingInstance.close()
          
          this.code = res.body.lineCode
          this.saveOkQuestion()

          //刷新列表
          this.$eventBus.$emit('lineTableReload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },

    saveOkQuestion() {
      this.$alert('线路数据保存成功', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.closeCurPage()
        },
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
